import type { MeResponse, User } from './users';

/** Why a row's edit / delete actions are unavailable, or `null` when the caller may act on it. */
export type UserActionBlock = 'self' | 'deleted' | 'owner-target' | null;

/**
 * Mirrors the server's `UsersApi.update` / `UsersApi.delete` guards so the admin page can disable
 * actions the server would refuse. The server stays the authority. This only spares the operator a
 * 403. Order matches the server: self first, then the OWNER target guard.
 */
export function userActionBlock(me: MeResponse | undefined, target: User): UserActionBlock {
  if (me?.email === target.email) return 'self';
  if (target.isDeleted) return 'deleted';
  if (target.role === 'OWNER' && !(me?.permissions.includes('ASSIGN_OWNER') ?? false)) return 'owner-target';
  return null;
}
